import { Component, inject, OnInit } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { Router, RouterOutlet } from '@angular/router'
import { AuthService } from '@auth0/auth0-angular'
import { FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { NgxPermissionsModule } from 'ngx-permissions'

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgxPermissionsModule],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas, far)
    }
}
